angular.module('st').controller('crewardsSubscriptionPaymentController', ['$scope','$http', function ($scope, $http) {

    $scope.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    $scope.processing = false;
    $scope.model = {};
    $scope.form = {
        fields: {},
        labels: {
            cvv: 'CVV',
            cardBrand: 'Card'
        }
    };

    const makeField = function (id, placeholder) { return { id: placeholder } };

    const btForm = {
        fields: {
            cardholderName: makeField('#cc-name', 'Name on card'),
            cardNumber: makeField('#cc-number', 'Card Number'),
            cvv: makeField('#cc-cvv', '123'),
            expirationMonth: makeField('#cc-expiration-month', 'Month'),
            expirationYear: makeField('#cc-expiration-year', 'Year'),   
            postalCode: makeField('#cc-zip-code', 'Zip Code')
        },
        classes: {
            valid: 'is-valid',
            invalid: 'is-invalid'
        },
        hostedFieldsInstance: null
    };
    const btFunctions = {};

    $scope.submitForm = function () {
        if ($scope.validateForm()) {
            btForm.hostedFieldsInstance.tokenize({
                cardholderName: $scope.form.fields.cardholderName
            }, function(err, payload) {
                if (err) {
                    console.error(err);
                    return;
                }

                $scope.processing = true;
                
                let params = {
                    nonce: payload.nonce
                };
                console.log('payload')
                console.log(payload)
                $http.post("/rpc/membership/account/payment-method/add/" + payload.nonce)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                $scope.processing = false;
                                console.log('success!!!')
                            } else {
                                // vista error
                                $scope.processing = false;
                                $scope.feedback = 'Error: ' + data.data.Message;
                            }
                        }).catch(function (error) {
                            // our server error
                            $scope.processing = false;
                            $scope.feedback = 'Error occurred while trying to remove this credit card.'
                        })
                //$http.post("/rpc/order/check-nonce", params)
                //    .then(function (d) {
                //        if (d.data.Success == true) {
                //            if (d.data.Data.Processed == true) {
                //                $scope.formFeedback = "Success: " + d.data.Data.ProcessorResponse.AuthorizationCode;
                //            }
                //            else {
                //                $scope.formFeedback = "Fail: " + d.data.Data.ProcessorResponse.ResponseText;
                //            }
                //        } else {
                //            // vista error
                //            $scope.processing = false;
                //            $scope.formFeedback = 'Error: ' + d.data.Message;
                //        }
                //    }).catch(function (error) {
                //        // our server error
                //        $scope.processing = false;
                //        $scope.formFeedback = 'Error occurred while trying to submit the form.'
                //    })
            });
        }       
    };     

    $scope.validateForm = function () {
        var formIsInvalid = false;
        var state = btForm.hostedFieldsInstance.getState();

        // non-hosted fields
        if (!btFunctions.validateInput($(btForm.fields.cardholderName.id))) {
            formIsInvalid = true;
        }

        // Loop through the Hosted Fields
        Object.keys(state.fields).forEach(function(field) {
            if (!state.fields[field].isValid) {
                $(state.fields[field].container).addClass(btForm.classes.invalid);
                formIsInvalid = true;
            }
        });

        return !formIsInvalid;
    };

    //***** Braintree funcs
    btFunctions.createInputChangeEventListener = function (element) {
        return function () {
            btFunctions.validateInput(element);
        }
    };

    btFunctions.setValidityClasses = function (element, validity) {
        if (validity) {
            element.removeClass(btForm.classes.invalid);
            element.addClass(btForm.classes.valid);  
        } 
        else {
            element.addClass(btForm.classes.invalid);
            element.removeClass(btForm.classes.valid);  
        }    
    };  

    btFunctions.validateInput = function (element) {

        if (!element.val().trim()) {
            btFunctions.setValidityClasses(element, false);
            return false;
        }

        btFunctions.setValidityClasses(element, true);
        return true;
    };

    btFunctions.validityChanged = function (event) {
        var field = event.fields[event.emittedBy];

        // Remove any previously applied error or warning classes
        $(field.container).removeClass(btForm.classes.valid).removeClass(btForm.classes.invalid);

        if (field.isValid) {
            $(field.container).addClass(btForm.classes.valid);
        } 
        else if (!field.isPotentiallyValid) {
            $(field.container).addClass(btForm.classes.invalid);
        }
    };

    btFunctions.cardTypeChanged = function (event) {
        $scope.$evalAsync(function() { 
            if (event.cards.length === 1) {
                var card = event.cards[0];
                $scope.form.labels.cardBrand = card.niceType;
                $scope.form.labels.cvv = card.code.name;
            } 
            else {
                $scope.form.labels.cardBrand = 'Card';
                $scope.form.labels.cvv = 'CVV';
            }
        });
    };
    //****** End Braintree funcs

    $scope.initBraintree = function () {
        braintree.client.create({
            authorization: $scope.model.ClientToken
        }, function(err, clientInstance) {
            if (err) {
                console.error(err);
                return;
            }

            braintree.hostedFields.create({
                client: clientInstance,
                styles: {
                    input: {
                        // change input styles to match
                        // bootstrap styles
                        'font-size': '1rem',
                        color: '#495057'
                    }
                },
                fields: {
                    number: {
                        selector: btForm.fields.cardNumber.id,
                        placeholder: btForm.fields.cardNumber.placeholder
                    },
                    cvv: {
                        selector: btForm.fields.cvv.id,
                        placeholder: btForm.fields.cvv.placeholder
                    },
                    expirationMonth: {
                        selector: btForm.fields.expirationMonth.id,
                        placeholder: btForm.fields.expirationMonth.placeholder,
                        select: { 
                            options: $scope.months 
                        }
                    },
                    expirationYear: {
                        selector: btForm.fields.expirationYear.id,
                        placeholder: btForm.fields.expirationYear.placeholder,
                        select: true
                    },
                    postalCode: {
                        selector: btForm.fields.postalCode.id,
                        placeholder: btForm.fields.postalCode.placeholder,
                    }
                }
            }, function(err, hostedFieldsInstance) {
                if (err) {
                    console.error(err);
                    return;
                }

                btForm.hostedFieldsInstance = hostedFieldsInstance;
                btForm.hostedFieldsInstance.on('validityChange', btFunctions.validityChanged);
                btForm.hostedFieldsInstance.on('cardTypeChange', btFunctions.cardTypeChanged);
            });
        });
    };

    $scope.init = function (model) {
        console.log('INITING')
        $scope.model = model;
        $scope.initBraintree();
    };    
}]);